import { type Transition, type Variant, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

export enum PriceGameSharedVariant {
    Initial = 'sharedInitial',
    Show = 'sharedShow',
    Exit = 'sharedExit',
}

const priceGameCommonTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
    staggerChildren: framerMotion.duration.fast,
};

const priceGameHiddenVariant: Variant = {
    opacity: 0,
    transition: {
        ...priceGameCommonTransition,
        when: 'afterChildren',
    },
};

export const priceGameVariants: Variants = {
    [PriceGameSharedVariant.Initial]: priceGameHiddenVariant,
    [PriceGameSharedVariant.Exit]: priceGameHiddenVariant,
    [PriceGameSharedVariant.Show]: {
        opacity: 1,
        transition: {
            ...priceGameCommonTransition,
            staggerDirection: -1,
            when: 'beforeChildren',
        },
    },
};

///
/// Label

export const labelVariants: Variants = {
    [PriceGameSharedVariant.Initial]: {
        opacity: 0,
        translateX: -8,
    },
    [PriceGameSharedVariant.Show]: {
        opacity: 1,
        // BUG: We need to keep a single pixel `translateX`.
        // Resetting back to `0` (or `none)` causes a very small
        // shift on the `textNode` within the <Label />.
        translateX: 1,
    },
    [PriceGameSharedVariant.Exit]: {
        opacity: 0,
        translateX: 8,
    },
};

export const labelTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.normal,
};

///
/// Ornament

const ornamentHiddenVariant: Variant = {
    opacity: 0,
    clipPath: 'polygon(48% 0%, 52% 0%, 52% 100%, 48% 100%)',
};

export const ornamentVariants: Variants = {
    [PriceGameSharedVariant.Initial]: ornamentHiddenVariant,
    [PriceGameSharedVariant.Exit]: ornamentHiddenVariant,
    [PriceGameSharedVariant.Show]: {
        opacity: 1,
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    },
};

export const ornamentTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
};
